export const MODAL_DESCRIPTION: {[key: string]: string } = {
  REMOVE: 'Are you sure you want to remove ## ** ## publisher(s) from the group?',
  REMOVE_METADATA: 'Once removed, publishers will no longer earn commissions associated with this group and all their links associated with campaigns for this group will be disabled.',
  ADD: 'Are you sure you want to add ## ** ## publisher(s) to the group?',
};
